module.exports = __webpack_public_path__ + "img/bw.28d1d50e.svg";